// src/components/InfrastructureWMSLayer.jsx
import { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const InfrastructureWMSLayer = ({ view }) => {
  useEffect(() => {
    if (!view || !view.map) return;

    let infrastructureLayer;

    loadModules(['esri/layers/WMSLayer']).then(([WMSLayer]) => {
      infrastructureLayer = new WMSLayer({
        title: 'Infrastructure',
        url: 'https://portal.boom-h2-pipelines.com/geoserver/Infrastructure/wms?'
      });

      infrastructureLayer.load().then(() => {
        const allSublayerNames = [
          'pipeline_feature', 'pipeline', 'mast', 'petroleum_site', 'petroleum_well',
          'power_compensator', 'power_generator_point', 'power_generator_polygon',
          'power_line', 'power_plant', 'power_substation_point', 'power_substation_polygon',
          'power_switch', 'power_tower', 'power_transformer', 'pumping_station',
          'telecom_building_point', 'telecom_building_polygon', 'telecom_cable',
          'wastewater_plant', 'water_reservoir', 'water_tower_point',
          'water_tower_polygon', 'water_treatment_plant'
        ];

        const visibleSublayers = ['pipeline_feature', 'pipeline', 'power_plant'];
        const configuredSublayers = [];

        for (const name of allSublayerNames) {
          const lyr = infrastructureLayer.findSublayerByName(name);
          if (lyr) {
            lyr.queryable = true;
            lyr.popupEnabled = true;
            lyr.visible = visibleSublayers.includes(name);
            configuredSublayers.push(lyr);
          }
        }

        infrastructureLayer.sublayers = configuredSublayers.reverse();

        if (view.map) {
          view.map.add(infrastructureLayer);
        }
      });
    });

    return () => {
      if (infrastructureLayer && view?.map) {
        view.map.remove(infrastructureLayer);
      }
    };
  }, [view]);

  return null;
};

export default InfrastructureWMSLayer;
